exports.putIndivAction = async (id, field) => {
  const res = await axios.put(`/demande-indiv/${id}/action`, field);

  if (res && res.data && res.data.success) {
      return res.data.data;
  }

  throw new Error(res && res.data && res.data.message ? res.data.message : 'Erreur sur le serveur');
};
